
  export const NOTIFICATIONTEMPLATES_RECEIVED = "NOTIFICATIONTEMPLATES_RECEIVED";
  export const SET_NOTIFICATIONTEMPLATE = "SET_NOTIFICATIONTEMPLATE";
  export const CREATE_NOTIFICATIONTEMPLATE = "CREATE_NOTIFICATIONTEMPLATE";
  export const SET_PROPERTY_NOTIFICATIONTEMPLATE = "SET_PROPERTY_NOTIFICATIONTEMPLATE";
  